import moment from 'moment-timezone';
import * as R from 'ramda';

const asc = (a, b) => a - b;
const isOccurrence = t => t?.includes('occurrence');
const toOccurrence = t => moment(t?.replace('occurrence', ''), 'YYYYMMDDHHmm');
const isAfterToday = t => t?.isSameOrAfter(moment());
export const hasOccurrences = post => post?.internal_tags?.filter(isOccurrence).length > 0;
export const getOccurrences = post => post?.internal_tags?.filter(isOccurrence)?.map(toOccurrence);
export const getFutureOccurrences = post => getOccurrences(post)?.filter(isAfterToday)?.sort(asc);
export const getOccurrencesAfterDate = (post, sendDate) =>
  getOccurrences(post)
    ?.filter(t => t.isSameOrAfter(moment(sendDate)))
    ?.sort(asc);

export const mapPostToNewsItem = post => {
  const images = ['share_image', 'social_teaser_image', 'image', 'teaser_image', 'image600x600', 'image300x300'];
  const attribute = images.find(img => post[img]);
  const image_url = post[attribute];
  const first = hasOccurrences(post) ? R.head(getFutureOccurrences(post)) : null;

  const getPublishDate = () => {
    if (first) return first;
    if (post?.last_published_ts) return post.last_published_ts;
    return post.created_ts;
  };

  return {
    id: post.id,
    headline: post.headline,
    created_ts: first ? first.unix() : post.created_ts,
    date: getPublishDate(post.created_ts),
    image_url,
    url: post.post_url,
    promoted: post.internal_tags?.includes('promoted'),
    sections: post.sections,
    description: post.description,
    total_views: post.stats?.page_views_count || 0,
    author: post?.roar_authors ? post.roar_authors[0]?.title : post.authors_names[0],
    author_profile_url: '',
    author_avatar: post?.roar_authors ? post.roar_authors[0]?.avatar : post.authors_site_avatars[0],
  };
};
export const mapEventToNewsItem = (post, sendDate) => {
  const images = ['share_image', 'social_teaser_image', 'image', 'teaser_image', 'image600x600', 'image300x300'];
  const attribute = images.find(img => post[img]);
  const image_url = post[attribute];
  const first = hasOccurrences(post) ? R.head(getOccurrencesAfterDate(post, sendDate)) : null;

  return {
    id: post.id,
    headline: post.headline,
    created_ts: first ? first.unix() : post.created_ts,
    image_url,
    url: post.post_url,
    promoted: post.internal_tags?.includes('promoted'),
    sections: post.sections,
    description: post.description,
    total_views: post.stats?.page_views_count || 0,
    author: post?.roar_authors ? post.roar_authors[0]?.title : post.authors_names[0],
    author_profile_url: '',
    author_avatar: post?.roar_authors ? post.roar_authors[0]?.avatar : post.authors_site_avatars[0],
  };
};

export const toNewsItem = mapPostToNewsItem;
